import { refId } from '../../../../core/utils/lp-backend';

const coordinate = (location: any, key: 'latitude' | 'longitude'): number =>
  Number(location?.[key] ?? location?.[`_${key}`] ?? 0);

/**
 * A loop-pro branch in cb-client-admin-api's shape: `hub_id` from the hub reference, `location` as
 * `{latitude, longitude}`, and no reference fields (they reach the browser as serialised Firestore references).
 */
export const toCbBranch = (branch: any, hub_id?: string): any => {
  const { hub, created_by, three_pl_partners, ...rest } = branch;

  return {
    ...rest,
    hub_id: hub_id || branch.hub_id || refId(hub),
    location: {
      latitude: coordinate(branch.location, 'latitude'),
      longitude: coordinate(branch.location, 'longitude')
    },
    // Only the single-branch read carries the hub itself ({id, name, created_at}).
    ...(hub && typeof hub.name === 'string' ? { hub } : {})
  };
};

const isCoordinate = (value: any): boolean =>
  (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) &&
  Number.isFinite(Number(value));

/** Whether a stored or serialised location carries both coordinates (a real 0 counts; `''` does not). */
export const hasCoordinates = (location: any): boolean =>
  ['latitude', 'longitude'].every((key) => isCoordinate(location?.[key] ?? location?.[`_${key}`]));

export const byName = (a: { name?: string }, b: { name?: string }) =>
  (a.name ?? '').localeCompare(b.name ?? '');
